import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Auth from './Auth'; // <-- THE LIFESAVER IMPORT
import './App.css';
import { Helmet } from 'react-helmet-async';

const ADONISIAN_WHEEL_CONFIG = [
  { name: "Aries", start: 28.40, end: 53.48, symbol: "♈︎" },
  { name: "Taurus", start: 53.48, end: 90.25, symbol: "♉︎" },
  { name: "Gemini", start: 90.25, end: 118.02, symbol: "♊︎" },
  { name: "Cancer", start: 118.02, end: 138.16, symbol: "♋︎" },
  { name: "Leo", start: 138.16, end: 173.86, symbol: "♌︎" },
  { name: "Virgo", start: 173.86, end: 218.01, symbol: "♍︎" },
  { name: "Libra", start: 218.01, end: 241.13, symbol: "♎︎" },
  { name: "Scorpio", start: 241.13, end: 247.72, symbol: "♏︎" },
  { name: "Ophiuchus", start: 247.72, end: 266.38, symbol: "⛎︎" },
  { name: "Sagittarius", start: 266.38, end: 299.73, symbol: "♐︎" },
  { name: "Capricorn", start: 299.73, end: 327.42, symbol: "♑︎" },
  { name: "Aquarius", start: 327.42, end: 351.83, symbol: "♒︎" },
  { name: "Pisces", start: 351.83, end: 28.40, symbol: "♓︎" }
];

function About({ onBack }) {
  const [rotation, setRotation] = useState(0);

  // Scroll to top on load AND handle the spinning wheel
  useEffect(() => {
    window.scrollTo(0, 0); // <-- FIXES THE SCROLL BUG
    
    const interval = setInterval(() => {
      setRotation((prev) => (prev + 0.2) % 360);
    }, 30);
    return () => clearInterval(interval);
  }, []);

  const linkStyle = { 
  color: '#0d1117', 
  backgroundColor: '#ffca28', 
  padding: '10px 20px', 
  borderRadius: '4px', 
  textDecoration: 'none', 
  marginTop: '40px', 
  display: 'inline-block', 
  fontWeight: 'bold', 
  letterSpacing: '1px' 
};

  return (
    <div className="App-header" style={{ padding: '40px 20px', maxWidth: '900px', margin: '0 auto', textAlign: 'left' }}>

{/* 👇 THE ABOUT PAGE SEO SHIELD 👇 */}
      <Helmet>
        <title>About the Swiss Ephemeris Data | Adonisian Matrix</title>
        <meta name="description" content="Discover the mathematics behind the Adonisian Engine. We use the Swiss Ephemeris runtime path to calculate exact, real-time 13-sign astronomical boundaries." />
      </Helmet>

      <h1 style={{ color: '#00d4ff', fontSize: '2.5rem', marginBottom: '10px', textAlign: 'center' }}>Bridging Ancient Wisdom & Modern Understanding</h1>
      <p style={{ color: '#8b949e', textAlign: 'center', marginBottom: '40px', fontStyle: 'italic' }}>The human body as a microcosm, mirroring cosmic laws.</p>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '40px', alignItems: 'center' }}>
        
        {/* PASSIVE ISOLATED SPINNING WHEEL */}
        <div style={{ width: '320px', height: '320px', background: '#0d1117', padding: '10px', borderRadius: '50%', border: '1px solid #30363d' }}>
          <svg viewBox="0 0 100 100" aria-label="The 13-Sign Wheel mapping physical astrology to joint matrices" role="img" style={{ transform: `rotate(${rotation}deg)`, transformOrigin: '50% 50%' }}>
            <title>13-Sign Astro-Somatic Wheel</title>
            {ADONISIAN_WHEEL_CONFIG.map((sign) => {
              const startAngle = (sign.start - 90) * (Math.PI / 180);
              const endAngle = (sign.end - 90) * (Math.PI / 180);
              const midAngle = ((sign.start + (sign.end < sign.start ? sign.end + 360 : sign.end)) / 2 - 90) * (Math.PI / 180);
              const lx = 50 + 42 * Math.cos(midAngle);
              const ly = 50 + 42 * Math.sin(midAngle);
              const sx = 50 + 30 * Math.cos(midAngle);
              const sy = 50 + 30 * Math.sin(midAngle);

              return (
                <g key={`about-wheel-${sign.name}`}>
                  <path d={`M 50 50 L ${50 + 45 * Math.cos(startAngle)} ${50 + 45 * Math.sin(startAngle)}`} stroke="#21262d" strokeWidth="0.15" />
                  <text x={sx} y={sy} fontSize="3.5" fill="#ffca28" textAnchor="middle" dominantBaseline="middle">{sign.symbol}</text>
                  <text x={lx} y={ly} fontSize="1.8" fill="#8b949e" textAnchor="middle" transform={`rotate(${(midAngle * 180 / Math.PI) + 90}, ${lx}, ${ly})`}>
                    {sign.name.toUpperCase()}
                  </text>
                </g>
              );
            })}
          </svg>
        </div>

        {/* LITERATURE EXPLANATION MODULES */}
        <div style={{ color: '#c9d1d9', fontSize: '1.05rem', lineHeight: '1.8', width: '100%' }}>
          
          <h3 style={{ color: '#ffca28', fontSize: '1.5rem', borderBottom: '1px solid #30363d', paddingBottom: '10px' }}>I. Astronomical Verification: The 13th Sign</h3>
          <p>
            The foundation of the Adonisian system rests entirely upon objective astrophysical calculation. Traditional Western astrology freezes its parameters around a grid built centuries ago, ignoring axial precession—the slow, top-like wobble of the Earth's axis that alters our orientation to constellations. By utilizing <strong>Swiss Ephemeris runtime libraries</strong>, we pinpoint where the coordinates of celestial bodies physically map against true spatial constellations.
          </p>
          <p>
            This mathematical correction re-introduces the 13th ecliptic boundary: <strong>Ophiuchus</strong>. Despite its omission from mainstream astrology, Ophiuchus lies along the ecliptic and carries significant spiritual meaning. Associated with Asclepius, the Greek god of medicine, it symbolizes profound transformation, wisdom, and miraculous self-healing.
          </p>

          <h3 style={{ color: '#00d4ff', fontSize: '1.5rem', borderBottom: '1px solid #30363d', paddingBottom: '10px', marginTop: '40px' }}>
            II. Somatic Healing for Joint Pain via Cerebrospinal Fluid (CSF) Meditation
          </h3>
          <p>
            Physiologically, CSF acts as a crucial protective and homeostatic agent, acting as the brain's "internal river of life". However, from an esoteric perspective, CSF transcends its biological functions to hold profound spiritual significance. Ancient traditions interpret it as a "sacred oil," a "divine nectar," and a "fluid conductor of Source energy" carrying healing properties throughout the spinal column and brain.
          </p>
          <p>
            This bio-spiritual mechanism is deeply intertwined with the <strong>"Milk and Honey"</strong> metaphor of internal hormonal alchemy. This alchemy involves the endogenous release of specific neurochemicals:
          </p>
          <ul style={{ color: '#8b949e' }}>
            <li><strong style={{ color: '#ffffff' }}>Serotonin ("The Milk"):</strong> Nourishing mood regulation and stability, it is associated with deep contentment and well-being.</li>
            <li><strong style={{ color: '#ffffff' }}>Melatonin ("The Honey"):</strong> Promoting restorative processes, stillness, and deep insight, frequently activated during deep meditation.</li>
            <li><strong style={{ color: '#ffffff' }}>Dimethyltryptamine (DMT):</strong> Often dubbed the "spirit molecule," representing ultimate illumination and bridging physical and spiritual awareness.</li>
          </ul>

          <h3 style={{ color: '#ffca28', fontSize: '1.5rem', borderBottom: '1px solid #30363d', paddingBottom: '10px', marginTop: '40px' }}>III. Lunar Triggers & The Mental Matrix</h3>
          <p>
            The activation of this sacred secretion is intimately linked to celestial rhythms. The <strong>13 New Moons</strong> act as specific energetic windows—bio-spiritual triggers that empower the individual's birth star sign energy and prompt the brain's internal alchemical release. 
          </p>
          <p>
            When we harmonize these internal fluid dynamics with exact cosmic mechanics, we gain the ability to heal what we call the <strong>Mental Matrix</strong>. Emotional and energetic traumas create repetitive cycles within this matrix; however, the brain's capacity for neuroplasticity—the ability to physically "rewire" itself—provides the perfect scientific parallel to the esoteric idea of transforming and healing these deep mental patterns.
          </p>
          
          <div style={{ marginTop: '50px', padding: '20px', background: 'rgba(0, 212, 255, 0.05)', borderRadius: '8px', borderLeft: '4px solid #00d4ff', textAlign: 'center' }}>
            <p style={{ fontStyle: 'italic', color: '#c9d1d9', margin: 0 }}>
              "Trust and believe that it is okay to be you, the most beautiful you there ever was, there is, and that there ever will be because you are not a story that can be told twice, and there will never again be a stage for you to perform but this one right now. So, be you, the most beautiful you." - Adonis Ramirez 🫰</p>
          </div>

          {/* --- ABOUT PAGE REGISTRATION FUNNEL --- */}
          <div className="funnel-gate-container" style={{ width: '100%', maxWidth: '600px', margin: '60px auto 40px auto', padding: '30px', background: 'rgba(255,255,255,0.02)', border: '1px dashed #30363d', borderRadius: '12px', textAlign: 'center' }}>
            <h2 style={{ color: 'white', fontSize: '1.5rem' }}>Your Life Is Not An Approximation. 🌌</h2>
            <p style={{ color: '#8b949e', fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '20px' }}>
              Decode the macro-environmental triggers hiding in your birth chart. Stop living an unmapped life.
            </p>
            <div style={{ maxWidth: '350px', margin: '0 auto', background: '#0d1117', padding: '20px', borderRadius: '8px', border: '1px solid #30363d' }}>
              <Auth />
            </div>
          </div>

          {/* --- BOTTOM RETURN LINK --- */}
         <div style={{ textAlign: 'center', paddingBottom: '30px' }}>
        <Link to="/" style={linkStyle}>The Portal 📟</Link>
      </div>

        </div>
      </div>
    </div>
  );
}

export default About;